import { format } from "date-fns";

const dateLegible = (date: Date, fmt = "dd/MM/yyyy"): string => {
  const parsed = new Date(date);
  return format(parsed, fmt);
};

export { dateLegible };
